import Vue from 'vue';
import VCalendar from 'v-calendar';

// Use v-calendar & v-date-picker components
Vue.use(VCalendar);
import datePicker  from '@/components/widgets/picker/calendarPicker'
Vue.component('calendarPicker',datePicker);

